export default function isCyberSaleLive(): boolean {
  const CURRENT_MS = Date.now();
  const CYBER_SALE_LIVE_MS = 1733126400000; // Dec 2 2024 00:00:00 PST
  const CYBER_SALE_ENDS_MS = 1733558399000; // Dec 6 2024 23:59:59 PST

  return CURRENT_MS >= CYBER_SALE_LIVE_MS && CURRENT_MS <= CYBER_SALE_ENDS_MS;
}
